// Header.js
import React, { useState } from "react";
import * as S from './styles';
import logo from '../../assets/logo.png';
import bell from '../../assets/bell.png';
import { FormattedMessage } from 'react-intl';
import { MdMenu } from 'react-icons/md'; // Novo ícone de menu
import DrawerMenu from '../../components/DrawerMenu'; // Importando o DrawerMenu
import Ajuda from '../../components/Ajuda'; // Importando o DrawerMenu


function Header({ clickNotification }) {
  const [lateCount] = useState(0); // Inicializando com 0
  const [isMenuOpen, setIsMenuOpen] = useState(false); // Estado para abrir/fechar o menu
  const [isHelpModalOpen, setIsHelpModalOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen((prev) => !prev);
  };

  return (
    <>
      <S.Container>
        <S.RightSide>
          {/* Ícone de Menu no Header */}
          <button type="button" onClick={toggleMenu}>
            <MdMenu size={24} color="#cf0505" /> {/* Ícone de menu */}
          </button>
          <span className="dividir" />
          {lateCount > 0 && (
            <>
              <button onClick={clickNotification}>
                <img src={bell} alt="Notificação" />
                <span>{lateCount}</span>
              </button>
              <span className="dividir" />
            </>
          )}
        </S.RightSide>
        <S.LeftSide>
          <S.HelpText onClick={() => setIsHelpModalOpen(true)}>
            <FormattedMessage id="header.ajuda" defaultMessage="Ajuda" />
          </S.HelpText>
          <span className="dividir" />
          <img src={logo} alt="Logo" />
        </S.LeftSide>
      </S.Container>
      {isMenuOpen && <DrawerMenu closeDrawer={toggleMenu} />} {/* Renderiza o DrawerMenu se estiver aberto */}
      <Ajuda isOpen={isHelpModalOpen} onClose={() => setIsHelpModalOpen(false)} />
    </>
  );
}

export default Header;
